// Alte Kontakt-Links /admin/kontakte/<quelle>/<id> (⌘K-Suche, Anrufkarte, Lesezeichen):
// Mieter, Eigentümer und Dienstleister haben eigene Detailseiten; Unbekanntes führt zur Kontaktliste.
// (/admin/kontakte/kontakt/<id> hat eine eigene Route und landet nicht hier.)
import { kontaktZiel } from '../immobilien/openKontakt';

export function alterKontaktPfadZiel(quelle: string | undefined, id: string | undefined): string {
  if (id && (quelle === 'mieter' || quelle === 'eigentuemer' || quelle === 'dienstleister')) return kontaktZiel(id, quelle);
  if (id && quelle === 'kontakt') return kontaktZiel(id, 'kontakt');
  return '/admin/kontakte';
}
